import { useCallback } from 'react';
import styled from 'styled-components';
import { AppAudioPlayerControlsShuffle } from '@elfsight/icons';
import { getColorWithAlpha } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { PropsWithClassName } from '../../../../../types';
import { useTheme } from '../../../common';
import { useSource } from '../../../sources';
import type { DefaultButtonProps } from './DefaultButton';
import { DefaultButton } from './DefaultButton';
import { Icon } from './Icon';

export function Shuffle({
  className,
  ...forwardingProps
}: PropsWithClassName<DefaultButtonProps>) {
  const { textColor } = useTheme();
  const { accentColor, sourceType, messageShuffle } = useSettings();
  const { shuffle, setShuffle } = useSource();
  const onClick = useCallback(() => {
    setShuffle(!shuffle);
  }, [setShuffle, shuffle]);

  return (
    sourceType !== 'rss' &&
    sourceType !== 'radio' && (
      <ShuffleComponent
        className={className}
        onClick={onClick}
        title={messageShuffle}
        {...forwardingProps}
      >
        <Icon
          as={AppAudioPlayerControlsShuffle}
          fill={shuffle ? accentColor : getColorWithAlpha(textColor, 0.5)}
        />
      </ShuffleComponent>
    )
  );
}

export const ShuffleComponent = styled(DefaultButton)``;
